// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_sG8EE {
	background: #FFFFFF;
	border: 1px solid var( --color-base100 );
	border-radius: 8px;
	padding: 12px;
  }

.button__f82H {
  width: 100%;
}

.trText_yXiPl > :first-child {	
	padding-bottom : 22px;
}

.list_uKjlR {
  margin: var(--size-padLarge, 5px) auto 0 var(--size-padLarge, 16px);
}

.grid_sgC53 {
  display: grid;
  grid-template-columns: auto auto !important;
}

.even_zo9M0 {
	background: var( --color-detailEvenRow, rgba( 0, 0, 0, 0.05 ));
}

.odd_yARuq {
	background: var( --color-detailOddRow, rgba( 0, 0, 0, 0.0 ));
}

.label_Lm8aR {
	padding-top: calc( var( --size-padMedimum, 16px ) / 2 );
	padding-bottom: calc( var( --size-padMedimum, 16px ) / 2 );
	padding-left: var( --size-padLarge, 24px );
	padding-right: calc( var( --size-padLarge, 24px ) / 2 );
	display: flex;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}

.value_Y4xvf {
	padding-top: calc( var( --size-padMedimum, 16px ) / 2 );
	padding-bottom: calc( var( --size-padMedimum, 16px ) / 2 );
	padding-left: calc( var( --size-padLarge, 24px ) / 2 );
	padding-right: var( --size-padLarge, 24px );
	display: flex;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
  justify-content: flex-end !important;
	flex-grow: 1;
	text-align: right;
}

.link__qdUP {
	overflow: hidden;
	text-overflow: ellipsis;
}

.copy_LO_so {
	width: 24px;
}

.flex_XmSwd {
	max-width: 55%;
}

.hotline_vLpBL {
	min-width: 150px;
}

.radioButton_pjFKh {
	background-color: var( --color-white );
	border-radius : 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/dashboard/viewer/theftRecovery/views/TheftRecovery.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,wCAAwC;CACxC,kBAAkB;CAClB,aAAa;EACZ;;AAEF;EACE,WAAW;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;CACC,8DAA8D;AAC/D;;AAEA;CACC,4DAA4D;AAC7D;;AAEA;CACC,uDAAuD;CACvD,0DAA0D;CAC1D,0CAA0C;CAC1C,uDAAuD;CACvD,aAAa;CACb,WAAW;CACX,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,uDAAuD;CACvD,0DAA0D;CAC1D,sDAAsD;CACtD,2CAA2C;CAC3C,aAAa;CACb,WAAW;CACX,YAAY;CACZ,sBAAsB;EACrB,oCAAoC;CACrC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sCAAsC;CACtC,mBAAmB;AACpB","sourcesContent":[".container {\n\tbackground: #FFFFFF;\n\tborder: 1px solid var( --color-base100 );\n\tborder-radius: 8px;\n\tpadding: 12px;\n  }\n\n.button {\n  width: 100%;\n}\n\n.trText > :first-child {\t\n\tpadding-bottom : 22px;\n}\n\n.list {\n  margin: var(--size-padLarge, 5px) auto 0 var(--size-padLarge, 16px);\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: auto auto !important;\n}\n\n.even {\n\tbackground: var( --color-detailEvenRow, rgba( 0, 0, 0, 0.05 ));\n}\n\n.odd {\n\tbackground: var( --color-detailOddRow, rgba( 0, 0, 0, 0.0 ));\n}\n\n.label {\n\tpadding-top: calc( var( --size-padMedimum, 16px ) / 2 );\n\tpadding-bottom: calc( var( --size-padMedimum, 16px ) / 2 );\n\tpadding-left: var( --size-padLarge, 24px );\n\tpadding-right: calc( var( --size-padLarge, 24px ) / 2 );\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: border-box;\n}\n\n.value {\n\tpadding-top: calc( var( --size-padMedimum, 16px ) / 2 );\n\tpadding-bottom: calc( var( --size-padMedimum, 16px ) / 2 );\n\tpadding-left: calc( var( --size-padLarge, 24px ) / 2 );\n\tpadding-right: var( --size-padLarge, 24px );\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: border-box;\n  justify-content: flex-end !important;\n\tflex-grow: 1;\n\ttext-align: right;\n}\n\n.link {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.copy {\n\twidth: 24px;\n}\n\n.flex {\n\tmax-width: 55%;\n}\n\n.hotline {\n\tmin-width: 150px;\n}\n\n.radioButton {\n\tbackground-color: var( --color-white );\n\tborder-radius : 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_sG8EE`,
	"button": `button__f82H`,
	"trText": `trText_yXiPl`,
	"list": `list_uKjlR`,
	"grid": `grid_sgC53`,
	"even": `even_zo9M0`,
	"odd": `odd_yARuq`,
	"label": `label_Lm8aR`,
	"value": `value_Y4xvf`,
	"link": `link__qdUP`,
	"copy": `copy_LO_so`,
	"flex": `flex_XmSwd`,
	"hotline": `hotline_vLpBL`,
	"radioButton": `radioButton_pjFKh`
};
export default ___CSS_LOADER_EXPORT___;
